module.exports = __webpack_public_path__ + "static/media/oldRoboticsPortfolio.4baa68bf.webp";